"use strict";

var _defineProperty = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var redux_1 = require("redux");

var redux_form_1 = require("redux-form");

var rootReducer = function rootReducer(extras) {
  var reducers = {
    form: redux_form_1.reducer
  };

  if (extras) {
    reducers = _objectSpread(_objectSpread({}, reducers), extras);
  }

  return (0, redux_1.combineReducers)(reducers);
};

exports.default = rootReducer;